// material-ui
import { styled, Theme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

interface Props {
  theme: Theme;
  open: boolean;
}

const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }: Props) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // The paper is a flex column that no longer scrolls; the logo row must hold its height
  // rather than being compressed to make the nav list fit.
  flexShrink: 0,
  paddingRight: open ? theme.spacing(1) : 0
}));

export default DrawerHeaderStyled;
